"use client";

import React from "react";
import { WalletButtonTMA } from "./WalletButton.tma";
import { WalletButtonWeb } from "./WalletButton.web";
import { WalletButtonProps } from "./types";
import { ConditionalRender } from "@/components/shared/ConditionalRender";

export const WalletButton = (props: WalletButtonProps) => {
  return (
    <ConditionalRender
      tmaComponent={<WalletButtonTMA className={props.className} />}
      webComponent={<WalletButtonWeb {...props} />}
    />
  );
};
